import { gridTpl } from '../../../../common/grid/grid.controller';

export const equipmentDocumentsGrid = {
    bindings: {
        onRemove: '&'
    },
    controller: 'EquipmentDocumentsGridController',
    ...gridTpl
};
